<template>
  <div>
    <Header/>
    <div class="zwB "></div>
    <div class="bodyBG2">
      <div class="curBoxb">
        <BreadCrumb/>
      </div>
      <div class="zcglBa">
      </div>
      <div class="listPBa">
        <CompanyIntroductionsLeftNav/>
        <div class="listPBr">
          <div class="docTitleB">
            <h1>
              {{$t('company_introductions')}}
            </h1>
            <div class="timeB">
              {{$t('belonging_to')}} {{$t('company_introductions')}} {{$t('author')}} {{$t('tajik_securities')}}
              {{$t('update_time')}}：2020-06-03 14:03:36
            </div>
          </div>
          <div class="docHtmlB">
            <div class="TRS_Editor">
              <p align="left" class="MsoNormal" style="background-size: initial; background-origin: initial; background-clip: initial">
            　　 <font face="微软雅黑" style="line-height: 200%;">&nbsp;
                  <span style="color: rgb(85, 85, 85); line-height: 200%;">
                    {{$t('home_about_us_text_one')}}
                  </span>
                </font>
              </p>
              <p class="MsoNormal" align="left" style="text-align:left;line-height:200%;&#10;;background:white">
            　　<span style="line-height: 200%; color: rgb(85, 85, 85);">
                  <font face="微软雅黑" style="line-height: 200%;">
                    {{$t('home_about_us_text_two')}}
                  </font>
                </span>
              </p>
              <p class="MsoNormal" align="left" style="text-align:left;line-height:200%;&#10;;background:white">
                <span style="line-height: 200%; color: rgb(85, 85, 85);">
                  <font face="微软雅黑" style="line-height: 200%;">
                    {{$t('home_about_us_text_three')}}
                  </font>
                </span>
              </p>
          </div>
          <p class="docHtmlB"></p>
        </div>
      </div>
    </div>
  </div>
      <Footer/>
  </div>
</template>
<script>
    import Footer from "../components/Footer";
    import Header from "../components/Header";
    import CompanyIntroductionsLeftNav from "../components/CompanyIntroductionsLeftNav";
    import BreadCrumb from "../components/BreadCrumb";

    export default {
        components: {BreadCrumb, CompanyIntroductionsLeftNav, Footer, Header}
    }
</script>
<style lang="scss" scoped>
@import url('../css/2020_swiper.min.css');
@import url('../css/public_20200313v4.css');
@import url('../css/index.css');
@import url('../css/public_footer.css');
@import url('../css/zxStyle.css');
@import url('../css/zxPubliceStyle.css');
@import url('../css/shzr_zr2020.css');
</style>
<style scoped>
    .zwB {
        height: 130px;
    }
    .TRS_Editor p{
        text-indent: 2em;
    }
</style>